import { http } from 'utils/http'

import { Account } from './types'

export const accountApi = {
  getAccounts(getState: () => unknown) {
    return http.get(getState, 'account/accounts', {})
  },
  createAccount(getState: () => unknown, account: Partial<Account>) {
    return http.post(getState, 'account', account)
  },
  removeUser(getState: () => unknown, userId: string) {
    return http.delete(getState, `account/users/${userId}`)
  },

  checkRole(getState: () => unknown) {
    return http.post(getState, `account/users/check`, {})
  },
  sendEmailVerification(getState: () => unknown, userId: string) {
    return http.post(getState, `account/users/${userId}/send`, {})
  },
  requestChangePasswordEmail(getState: () => unknown, userId: string) {
    return http.post(getState, `account/users/${userId}/password`, {})
  },
  activation(getState: () => unknown, userId: string) {
    return http.post(getState, `account/users/${userId}/activation`, {})
  },

  getUsers(getState: () => unknown) {
    return http.get(getState, `account/users`)
  },
}
